(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-with-text"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_with_text = () => {
		let headerOverlay = document.querySelector('.overlay');
		let pageAbout = document.querySelector('.page-about');
		let pageLookbook = document.querySelector('.page-lookbook');
		let breadCrumb = document.querySelector('.main-breadcrumb');
		let colorScheme = document.querySelector('.header-color-light');
		let colorSchemeDark = document.querySelector('.header-color-dark');
		let firstSection = document.querySelector('main section:first-of-type');

		if (
			headerOverlay &&
			firstSection.classList.contains('section-banner-with-text')
		) {
			document.querySelector('main').classList.add('page-about');
			let pageAbout = document.querySelector('.page-about');
			let pageLookbook = document.querySelector('.page-lookbook');
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.add('color-background-5');
				}
			} 

			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.remove('color-background-5');
				}
			}
		} else {
			if (colorScheme) {
				if (pageAbout || pageLookbook) {
					breadCrumb && breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				if (pageAbout || pageLookbook) {
					breadCrumb &&	breadCrumb.classList.remove('color-background-5');
				}
			}
		}
	};

	banner_with_text();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_with_text();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });

      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: true,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        on: {
          click: function (e) {
            if (this.zoom.scale === 1) {
              this.zoom.in();
            } else {
              this.zoom.out();
            }
          },
        },
      });

      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();

      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Initialize wishlist hearts after content is loaded
              if (typeof updateWishlistHearts === 'function') {
                updateWishlistHearts();
              }

              // Also initialize after a short delay to ensure DOM is ready
              setTimeout(() => {
                if (typeof updateWishlistHearts === 'function') {
                  updateWishlistHearts();
                }
              }, 100);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.header_overlay = document.querySelector('.header');
      this.headerOverlay = document.querySelector('.overlay');

      this.headerBounds = {};
      this.predictiveSearch = this.querySelector('predictive-search');
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.header_overlay) {
        if (scrollTop > 0) {
          this.header_overlay.classList.add('header_overlay-scroll');
        } else {
          this.header_overlay.classList.remove('header_overlay-scroll');
        }
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      /* no-op: hide behavior removed */
    }

    reveal() {
      /* no-op: reveal behavior removed; rely on scroll to toggle background */
    }

    reset() {
      /* no-op: reset behavior removed */
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];

  const header_overlay = () => {
    let headerOverlay = document.querySelector('.overlay');
    let headerHeightOverlay = headerOverlay && headerOverlay.offsetHeight;

    document.documentElement.style.setProperty('--my-header-height', headerHeightOverlay + 'px');

    if (headerOverlay) {
      document.querySelector('main').classList.add('header_overlay');
    } else {
      document.querySelector('main').classList.remove('header_overlay');
    }
  };

  header_overlay();

  events.forEach(function (item) {
    document.addEventListener(item, function () {
      header_overlay();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
	for (const p of document.querySelectorAll('.article-template__content p')) {
		if (p.innerText == p.innerHTML) {
			p.classList.add('only');
		}
	}

	for (const p of document.querySelectorAll(
		'.article-template__content p > a'
	)) {
		p.parentElement.classList.add('only');
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const blog_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	blog_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			blog_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];

  const main_collection_banner = () => {
    let headerOverlay = document.querySelector('.overlay');
    let colorScheme = document.querySelector('.header-color-light');

    if (headerOverlay) {
      if (colorScheme) {
        headerOverlay.classList.add('theme-dark');
        headerOverlay.classList.add('header-color-background-5');
      } else {
        headerOverlay.classList.remove('theme-dark');
        headerOverlay.classList.remove('header-color-background-5');
        headerOverlay.classList.add('color-background-1');
      }
    }
  };

  main_collection_banner();

  events.forEach(function (item) {
    document.addEventListener(item, function () {
      main_collection_banner();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      //this.showActiveMedia();
      this.constProductPageSwiperCall();
    }
    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');

      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    constProductPageSwiperCall(showActiveMedia) {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      let activeMediaIndex = 0;

      this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
        if (element == activeMedia) {
          activeMediaIndex = index;
        }
      });

      const prodPageSwiper = new Swiper('#product-page-swiper', {
        zoom: window.matchMedia('(hover: hover) and (pointer: fine)').matches,
        centeredSlides: false,
        slidesPerView: 1,
        autoheight: true,
        watchSlidesVisibility: false,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        init: false,
        navigation: {
          nextEl: '.swiper-button-next-prod-page',
          prevEl: '.swiper-button-prev-prod-page',
        },
        pagination: {
          el: '.swiper-pagination-product-page',
          clickable: true,
        },
        on: {
          click: function (e) {
            if (!this.zoom) return;
            if (this.zoom.scale === 1) {
              this.zoom.in();
            } else {
              this.zoom.out();
            }
          },
        },
      });

      prodPageSwiper.on('init', function () {
        prodPageSwiper.slideTo(activeMediaIndex, 0, false);
      });
      prodPageSwiper.init();

      document.querySelector('.product-media-modal__toggle').addEventListener('click', function () {
        prodPageSwiper.destroy();
      });
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Initialize wishlist hearts after content is loaded
              if (typeof updateWishlistHearts === 'function') {
                updateWishlistHearts();
              }

              // Also initialize after a short delay to ensure DOM is ready
              setTimeout(() => {
                if (typeof updateWishlistHearts === 'function') {
                  updateWishlistHearts();
                }
              }, 100);
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  function initCustomProductImageModal() {
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)');
    if (!isDesktop.matches) return;

    const root = document.querySelector('.main-product-page');
    const gallery = root
      ? root.querySelector('.product__media-list__container--great-five')
      : document.querySelector('.product__media-list__container--great-five');
    const modal = root
      ? root.querySelector('.custom-product-modal')
      : document.querySelector('.custom-product-modal');

    console.log('CustomProductModal: root/gallery/modal lookup', {
      hasRoot: !!root,
      hasGallery: !!gallery,
      hasModal: !!modal,
    });

    if (!root || !gallery || !modal) {
      return;
    }

    const imageElements = Array.from(
      gallery.querySelectorAll('.product__media-item img')
    );

    if (!imageElements.length) {
      console.log('CustomProductModal: no desktop gallery images found');
      return;
    }

    console.log('CustomProductModal: found images', imageElements.length);

    const state = {
      index: 0,
      items: imageElements.map((img) => ({
        src: img.currentSrc || img.src,
        srcset: img.srcset || '',
        alt: img.alt || '',
      })),
    };

    const dialog = modal.querySelector('.custom-product-modal__dialog');
    const imageWrapper = modal.querySelector('.custom-product-modal__image-wrapper');
    const image = modal.querySelector('.custom-product-modal__image');
    const counter = modal.querySelector('.custom-product-modal__counter');
    const btnClose = modal.querySelector('.custom-product-modal__close');
    const btnPrev = modal.querySelector('.custom-product-modal__prev');
    const btnNext = modal.querySelector('.custom-product-modal__next');

    if (!dialog || !imageWrapper || !image || !counter || !btnClose || !btnPrev || !btnNext) {
      console.log('CustomProductModal: missing inner elements');
      return;
    }

    let zoomLevel = 0;
    const zoomSteps = [1, 1.7, 2.8];

    function resetZoom() {
      zoomLevel = 0;
      imageWrapper.classList.remove('is-zoomed');
      image.style.transformOrigin = 'center center';
      image.style.transform = 'scale(1)';
    }

    function updateZoomOrigin(event) {
      if (zoomLevel === 0) return;
      const rect = imageWrapper.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      const xClamped = Math.max(0, Math.min(100, x));
      const yClamped = Math.max(0, Math.min(100, y));
      image.style.transformOrigin = `${xClamped}% ${yClamped}%`;
    }

    function updateView() {
      const item = state.items[state.index];
      if (!item) return;

      image.src = item.src;
      if (item.srcset) {
        image.srcset = item.srcset;
      } else {
        image.removeAttribute('srcset');
      }
      image.alt = item.alt || '';
      counter.textContent = `${state.index + 1} / ${state.items.length}`;
      resetZoom();
    }

    function openAt(index) {
      state.index = Math.max(0, Math.min(index, state.items.length - 1));
      updateView();
      modal.classList.add('custom-product-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('custom-product-modal-open');
      resetZoom();
    }

    function closeModal() {
      modal.classList.remove('custom-product-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('custom-product-modal-open');
      resetZoom();
    }

    function showNext() {
      state.index = (state.index + 1) % state.items.length;
      updateView();
    }

    function showPrev() {
      state.index =
        (state.index - 1 + state.items.length) % state.items.length;
      updateView();
    }

    // Bind controls
    btnClose.addEventListener('click', closeModal);
    btnNext.addEventListener('click', showNext);
    btnPrev.addEventListener('click', showPrev);

    modal.addEventListener('click', (event) => {
      // Close when clicking backdrop (outside dialog/image area)
      if (!dialog.contains(event.target)) {
        closeModal();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!modal.classList.contains('custom-product-modal--open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showNext();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPrev();
      }
    });

    if (modal.dataset.zoomBound !== 'true') {
      imageWrapper.addEventListener('click', (event) => {
        if (event.target.closest('.custom-product-modal__close, .custom-product-modal__prev, .custom-product-modal__next, .custom-product-modal__counter')) {
          return;
        }

        zoomLevel = (zoomLevel + 1) % zoomSteps.length;
        const scale = zoomSteps[zoomLevel];
        imageWrapper.classList.toggle('is-zoomed', zoomLevel > 0);
        image.style.transform = `scale(${scale})`;

        if (zoomLevel === 0) {
          image.style.transformOrigin = 'center center';
        } else {
          updateZoomOrigin(event);
        }
      });

      imageWrapper.addEventListener('mousemove', (event) => {
        if (!modal.classList.contains('custom-product-modal--open')) return;
        updateZoomOrigin(event);
      });

      modal.dataset.zoomBound = 'true';
    }

    // Ensure reliable click target for each image
    imageElements.forEach((img, index) => {
      const item = img.closest('.product__media-item');
      if (!item) return;

      if (item.dataset.customModalBound === 'true') return;
      item.dataset.customModalBound = 'true';

      let trigger = item.querySelector('.custom-product-modal__trigger');
      if (!trigger) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'custom-product-modal__trigger';
        trigger.setAttribute('aria-label', '{{ "products.product.open_media" | t | default: "Open image" }}');
        item.appendChild(trigger);
      }

      trigger.dataset.index = String(index);

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const i = parseInt(trigger.dataset.index || '0', 10);
        console.log('CustomProductModal: open from trigger index', i);
        openAt(isNaN(i) ? 0 : i);
      });
    });
  }

  // Add Buy It Now button functionality
  document.addEventListener('DOMContentLoaded', function () {
    const buyItNowButton = document.querySelector('.buy-it-now-button');
    const dynamicCheckoutContainer = document.querySelector('.dynamic-checkout-container');

    if (buyItNowButton && dynamicCheckoutContainer) {
      buyItNowButton.addEventListener('click', function () {
        buyItNowButton.style.display = 'none';
        dynamicCheckoutContainer.style.display = 'block';
      });
    }

    initCustomProductImageModal();
    setTimeout(initCustomProductImageModal, 500);
    setTimeout(initCustomProductImageModal, 1200);
    setTimeout(initCustomProductImageModal, 2000);
  });

  window.addEventListener('load', function () {
    initCustomProductImageModal();
    setTimeout(initCustomProductImageModal, 500);
    setTimeout(initCustomProductImageModal, 1200);
  });

  // Color filtering moved to assets/color-image-filter.js
  function bindMainProductPopup() {
    const root = document.getElementById('MainProduct-{{ section.id }}');
    const modal = document.getElementById('ProductModal-{{ section.id }}');

    if (!root || !modal || typeof modal.show !== 'function') return;

    const galleryItems = Array.from(
      root.querySelectorAll('.product__media-list__container--great-five .product__media-item')
    );

    const modalSlides = Array.from(
      modal.querySelectorAll('.swiper-slide[data-media-id]')
    );

    if (!galleryItems.length || !modalSlides.length) return;

    galleryItems.forEach((item, index) => {
      if (item.dataset.popupBound === 'true') return;
      item.dataset.popupBound = 'true';
      item.style.cursor = 'zoom-in';

      item.addEventListener('click', function (event) {
        if (
          event.target.closest('.wishlist-heart') ||
          event.target.closest('.phone-media-carousel__dots') ||
          event.target.closest('.phone-media-carousel__wrapper') ||
          event.target.closest('.breadcrumb')
        ) {
          return;
        }

        const targetSlide = modalSlides[index] || modalSlides[0];
        if (!targetSlide) return;

        const mediaId = targetSlide.getAttribute('data-media-id');
        if (!mediaId) return;

        const opener = document.createElement('button');
        opener.type = 'button';
        opener.setAttribute('data-media-id', mediaId);
        opener.style.display = 'none';
        document.body.appendChild(opener);

        try {
          modal.show(opener);
        } catch (error) {
          console.error('Product modal open failed:', error);
        }

        setTimeout(() => {
          opener.remove();
        }, 0);
      });
    });
  }

  // Existing color popup bindings are no longer used for the desktop gallery modal.
  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const account_header_overlay = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-light');

		if (headerOverlay) {
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} else {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	account_header_overlay();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			account_header_overlay();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-also-like');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              if (typeof updateWishlistHearts === 'function') {
                updateWishlistHearts();
              }
              setTimeout(() => {
                if (typeof updateWishlistHearts === 'function') {
                  updateWishlistHearts();
                }
              }, 100);

              // Card click navigation is now handled globally in CardController

              // Initialize mobile drag carousel
              try {
                const list = this.querySelector('.product-recommendations__list');
                if (list) {
                  let isDown = false;
                  let startX;
                  let scrollLeft;

                  list.addEventListener('mousedown', (e) => {
                    isDown = true;
                    list.classList.add('dragging');
                    startX = e.pageX - list.offsetLeft;
                    scrollLeft = list.scrollLeft;
                  });

                  list.addEventListener('mouseleave', () => {
                    isDown = false;
                    list.classList.remove('dragging');
                  });

                  list.addEventListener('mouseup', () => {
                    isDown = false;
                    list.classList.remove('dragging');

                    const firstItem = list.querySelector('.product-recommendations__product');
                    if (firstItem) {
                      const itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(list).gap || '0');
                      const currentScroll = list.scrollLeft;
                      const targetIndex = Math.round(currentScroll / itemWidth);
                      list.scrollTo({ left: targetIndex * itemWidth, behavior: 'smooth' });
                    }
                  });

                  list.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - list.offsetLeft;
                    const walk = (x - startX) * 1.5;
                    list.scrollLeft = scrollLeft - walk;
                  });
                }
              } catch (err) {
                console.warn('Recommendations carousel init error', err);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations-also-like', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slideshow"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_with_text = () => {
		let headerOverlay = document.querySelector('.overlay');
		let colorScheme = document.querySelector('.header-color-theme-light');
		let colorSchemeDark = document.querySelector('.header-color-theme-dark');
		let firstSection = document.querySelector('main section:first-of-type');

		if (
			headerOverlay &&
			firstSection.classList.contains('product-slideshow-section')
		) {
			document.querySelector('main').classList.add('page-about');
			if (colorSchemeDark) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
			} 

			if (colorScheme) {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
			}
		}
	};

	banner_with_text();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_with_text();
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const events = [
    'shopify:section:reorder',
    'shopify:section:deselect',
    'shopify:section:select',
    'shopify:section:unload',
    'shopify:section:load',
  ];

  const slideshow_section = () => {
    let headerOverlay = document.querySelector('.overlay');
    let page = document.querySelector('.template-page');
    let breadCrumb = document.querySelector('.main-breadcrumb');
    let firstSection = document.querySelector('main section:first-of-type');

    if (page && headerOverlay && firstSection.classList.contains('slideshow-section') && breadCrumb) {
      breadCrumb.classList.add('template-page-breadcrumb');
      if (headerOverlay.classList.contains('theme-dark')) {
        breadCrumb.classList.add('color-background-5');
      }
    }
  };

  slideshow_section();

  events.forEach(function (item) {
    document.addEventListener(item, function () {
      slideshow_section();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-grid"] && !Shopify.designMode) return;
  try {
    
  /* Editor interactions if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
	const events = [
		'shopify:section:reorder',
		'shopify:section:deselect',
		'shopify:section:select',
		'shopify:section:unload',
		'shopify:section:load',
	];

	const banner_video = () => {
		let headerOverlay = document.querySelector('.overlay');
		let pageAbout = document.querySelector('.page-about');
		let pageLookbook = document.querySelector('.page-lookbook');
		let breadCrumb = document.querySelector('.main-breadcrumb');
		let colorScheme = document.querySelector('.header-color-light');
		let colorSchemeDark = document.querySelector('.header-color-dark');
		let firstSection = document.querySelector('section:first-of-type');

		if (
			headerOverlay &&
			firstSection.classList.contains('video-banner-section')
		) {
			document.querySelector('main').classList.add('page-about');
			let pageAbout = document.querySelector('.page-about');
			let pageLookbook = document.querySelector('.page-lookbook');
			if (colorScheme) {
				headerOverlay.classList.add('theme-dark');
				headerOverlay.classList.add('header-color-background-5');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				headerOverlay.classList.remove('theme-dark');
				headerOverlay.classList.remove('header-color-background-5');
				headerOverlay.classList.add('color-background-1');
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		} else {
			if (colorScheme) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.add('color-background-5');
				}
			}

			if (colorSchemeDark) {
				if (pageAbout || pageLookbook) {
					breadCrumb.classList.remove('color-background-5');
				}
			}
		}
	};

	banner_video();

	events.forEach(function (item) {
		document.addEventListener(item, function () {
			banner_video();
		});
	});

  } catch(e) { console.error(e); }
})();
})();
